import {
  GET_CHANNEL_PARTNER_LISTING,
  GET_CONTRACTS_BY_CHANNEL_PARTNER,
} from "./type";

const initalState = {
  channelPartnerListing: null,
  contractsListByChannelPartner: null,
};

const channelPartnerReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CHANNEL_PARTNER_LISTING:
      return {
        ...state,
        channelPartnerListing: payload,
      };
    case GET_CONTRACTS_BY_CHANNEL_PARTNER:
      return {
        ...state,
        contractsListByChannelPartner: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default channelPartnerReducer;
